import { usePageDataStore } from '@/stores/pageDataStore';
import { computed } from 'vue';
/** @import { IExperimentId } from '@/types/definitions' */
/**
 * Composable for getting the experiment ids
 * @returns {IExperimentId}
 */
export default function useExperimentIds() {
  const pageDataStore = usePageDataStore();
  return {
    experimentIds: computed(() => pageDataStore.getExperimentIds || []),
  };
}
